import { useGetRichTextProps } from 'components/form/RichText/useGetRichTextProps'
import { PreviewMode } from 'services/Store/Project/enums'
import { useAnimatedNumberState } from 'utils/animationHooks'

import { useElementRootStyles } from '../../hooks/useElementRootStyles'
import * as s from './ListElement.module.scss'
import ListItemComponent from './ListItemComponent'
import type { ListElementType } from './listTypes'

const ANIMATION_VARIANTS = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0 },
}

const ListElement: ListElementType = (props) => {
  const { element, styles, mode } = props
  const { value } = element
  const rootStyles = useElementRootStyles(styles.root)
  const isEditor = mode.previewMode === PreviewMode.editor
  const isPdf = mode.previewMode === PreviewMode.pdf
  const [renderIndex, setRenderIndex] = useAnimatedNumberState(500)
  const rtProps = useGetRichTextProps({ elementId: element.id, mode })

  return (
    <ul className={s.list} style={rootStyles}>
      {value?.items?.map((item, i) => {
        const shouldAnimate = styles.animation.fade && !isEditor && !isPdf

        return (
          <ListItemComponent
            i={i}
            item={item}
            key={i}
            {...props}
            animationProps={
              shouldAnimate
                ? {
                    animate: i <= renderIndex ? 'visible' : 'hidden',
                    initial: 'hidden',
                    transition: { duration: 1 },
                    variants: ANIMATION_VARIANTS,
                  }
                : undefined
            }
            asMotion={shouldAnimate}
            onViewIndex={setRenderIndex}
            rtProps={rtProps}
          />
        )
      })}
    </ul>
  )
}

export default ListElement
